<template>
	<div class="ziying">
		<!-- 标题导航 -->
        <div class="nav">
            <div class="nav-area">
                <div class="return-label">
                    <img src="/photo/icon/LOGO-正钻.png" alt="首页">
                </div>
                <div class="slogan">
                    <img src="/photo/icon/slogan.png" alt="标题">
                </div>
                <div class="label">
                    <img src="/photo/icon/正品标签.png" alt="正品标签">
                </div>
            </div>
        </div>
		<!-- 提示框 -->
		<div class="prompt-info">
            <img :src="iconList.warn" alt="提示"/>
            <div class="info">
                <p>{{tooltip.title}}</p>
                <div class="archive">
                    {{tooltip.desc1}}<span class="waring">{{tooltip.desc2}}</span>{{tooltip.desc3}}<span class="waring">{{tooltip.desc4}}</span>{{tooltip.desc5}}
					<a
						class="environment"
						:href="tooltip.environment"
						target="_blank">
						<p>.NET Framework4.0 <span>下载</span></p>
					</a>
                </div>
            </div>
        </div>
		<!-- 产品软件列表 -->
        <div class="content">
			<!-- 循环 -->
            <div class="list" v-for="item in list" :key="item.id">
                <div class="title">{{item.model}}</div>
                <img class="product-img" :src="item.img" :alt="item.id">
				<!-- 下载按键 -->
                <div class="btn">
					<!-- 下载软件安装包 -->
					<a
                        class="left"
                        v-if="item.software"
						:href="item.software"
						target="_blank">
                        <span class="desc">{{buttonHint.hint1}}</span>
                        <div class="img-icon">
                            <img class="icon" :src="iconList.download" alt="图标">
                        </div>
                    </a>
					<!-- 跳转到软件云端登录页面 -->
                    <a
						class="software-url"
						v-if="item.softwareUrl"
						:href="item.softwareUrl"
						target="_blank">
						<span class="desc">{{buttonHint.hint2}}</span>
                        <div class="img-icon">
                            <img class="icon" :src="iconList.url" alt="图标">
                        </div>
                    </a>
					<!-- 软件操作视频 -->
                    <a
						class="right"
						v-if="item.video"
						:href="item.video"
						target="_blank">
						<span class="desc">{{buttonHint.hint3}}</span>
                        <div class="img-icon">
                            <img class="icon" :src="iconList.play" alt="图标">
                        </div>
                    </a>
					<!-- 软件说明书 -->
                    <a 
						class="manual" 
						v-if="item.manual" 
						:href="item.manual"
						target="_blank">
                        <span class="desc">{{buttonHint.hint4}}</span>
                        <div class="img-icon">
                            <img class="icon" :src="iconList.download" alt="图标">
                        </div>
                    </a>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
export default {
    name: 'Ziying',
    data () {
        return {
            // 时间戳
            timeStamp: 0,
            // 控制导航页面的显示-隐藏
            // homeIcon: 'show',
            // 提示框内容
            tooltip: {},
            // 图标列表
            iconList: {},
            // 产品软件列表
            list: [],
            // 按键提示内容
            buttonHint: {}
        }
    },
    created () {
        // 获取时间戳
        this.getTimeStamp()
        this.request()
    },
    // mounted () {
    //     this.changeNav()
    //     window.addEventListener('resize', this.resize)
    // },
    methods: {
        // 获取时间戳
        getTimeStamp () {
            this.timeStamp = new Date().getTime()
            // console.log(this.timeStamp)
        },
        // 获取静态json文件数据
        request () {
            this.$http.get('/mock/softwarelist.json', {
                params: {
                    timeStamp: this.timeStamp
                }
            })
                .then((res) => {
                    this.tooltip = res.data.data.tooltip
                    this.iconList = res.data.data.iconlist
                    this.list = res.data.data.list
                    this.buttonHint = res.data.data.downlaodhint
                })
        }
        // resize () {
        //     this.changeNav()
        // },
        // // 通过屏幕的宽度控制导航条的显示
        // changeNav () {
        //     var screenwidth = document.documentElement.clientWidth
        //     if (screenwidth < 900) {
        //         this.homeIcon = 'hide'
        //     } else {
        //         this.homeIcon = 'show'
        //     }
        // }
    }
}
</script>

<style lang="scss" scoped>
.ziying {
	display: flex;
	flex-direction: column;
	align-items: center;
    margin: 0 auto;
    width: 1050px;
	.nav {
		margin: 5px 0 0 0;
        width: 1040px;
        height: 175px;
        background: #fff;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
        .nav-area {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: center;
            margin: 0 10px;
            .return-label, .slogan, .labei {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            .return-label {
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .slogan {
                img {
                    width: auto;
                    height: 100px;
                }
            }
            .label {
                img {
                    height: 175px;
                    width: 175px;
                }
            }
        }
    }
	.prompt-info {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 1040px;
		height: 80px;
		background: #d6ebff;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		img {
			margin-left: 8px;
			height: 40px;
			width: 40px;
		}
		.info {
			margin-left: 10px;
			.warning {
				color: #ff0000;
				font-size: 16px;
			}
			.archive {
				display: flex;
				flex-direction: row;
				margin-top: 2px;
				height: 30px;
				line-height: 30px;
				font-weight: bold;
				.waring {
					color: #ff0000;
					font-weight: bold;
					font-size: 16px;
				}
				.environment {
					margin-left: 35px;
					color: #000;
					font-size: 15px;
					cursor: pointer;
					span {
						color:  #409EFF;
						font-size: 16px;
					}
				}
			}
		}
	}
	.content {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin-top: 15px;
		margin-left: 8px;
		.list {
			width: 20%;
			height: 300px;
			margin-bottom: 5px;
			.title {
				width: 200px;
				height: 30px;
				line-height: 30px;
				font-size: 20px;
				letter-spacing: 0.5px;
				text-align: center;
				color: #fff;
				background: #409eff;
			}
			.product-img {
				margin: 0;
				height: 200px;
				width: 200px;
				vertical-align: top;
			}
			.btn {
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				align-items: center;
				width: 200px;
				height: 50px;
				background: #d6ebff;
				.left, .right, .software-url, .manual {
					display: flex;
					flex-direction: row;
					justify-content: space-around;
					align-items: center;
					width: 80px;
					height: 25px;
					background: #fff;
					color: #000;
					text-decoration: none;
					border-radius: 10px;
					cursor: pointer;
					a {
						color: #000;
						text-decoration: none;
					}
					.desc {
						display: inline-block;
						margin-left: 3px;
						width: 60px;
						height: 20px;
						line-height: 20px;
						text-align: center;
						font-size: 12px;
						background: #fff;
						border-radius: 5px;
					}
					.img-icon  {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 25px;
						height: 25px;
						border-bottom-right-radius: 10px;
						border-top-right-radius: 10px;
						background: #409eff;
						.icon {
							margin: 0;
							width: 23px;
							height: 23px;
						}
					}
				}
			}
		}
	}
}
</style>
